declare namespace $ {

	type $shm_hitalama_agent_map_widget_session__widget_shm_hitalama_map_widget_float_opencode_session_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_opencode_session['widget'] >
		,
		ReturnType< $shm_hitalama_agent_map_widget_session['widget'] >
	>
	type $shm_hitalama_agent_map_widget_session__Map_page_shm_hitalama_map_widget_float_opencode_session_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_opencode_session['Map_page'] >
		,
		ReturnType< $shm_hitalama_agent_map_widget_session['Map_page'] >
	>
	export class $shm_hitalama_map_widget_float_opencode_session extends $shm_hitalama_map_widget_float {
		Chat( ): $shm_hitalama_agent_map_widget_session
		scrollable( ): boolean
		content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=session.view.tree.d.ts.map